import type { FaireProductEntity } from "../../entity_types/product";

export const p_ansnpw9cjc: FaireProductEntity = {
  token: "p_ansnpw9cjc",
  type: "product",
  name: "Ribbed Crop Top & Leggings Set",
  brandToken: "b_1f7p8ul7e0",
  brandName: "CAPELLA APPAREL",
  imageUrl:
    "https://cdn.faire.com/fastly/93a964336cc52efafbb40b9bee32c5a6ff1f4cfe7f633fc97ca047a9464bf3fa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a508ffc060a12a666dabe6faa4627113f67b66a53a88032ec2b3d8e64817ccb.jpeg",
    "https://cdn.faire.com/fastly/836ba689d13e2b59fdb62ef3312ff68b262104e74698c2f4f4bee042ec2f7775.jpeg",
    "https://cdn.faire.com/fastly/0d6ff8e8ce4c2a0f522dac76a944be2cbe5b7da98c98055e2bbb83c1e9fb1cba.jpeg",
    "https://cdn.faire.com/fastly/d9209b56a8944b5f3e23a52eadb9cd4e81ac1bf70238331f58c788a036481ba7.jpeg",
    "https://cdn.faire.com/fastly/13d5dcf4df544ed422df4e5c376e4983c8f2a952b853234dbbbccabfe9418aa2.jpeg",
    "https://cdn.faire.com/fastly/5fc9afba780c15c7bf34d9bdbf8fd91360c20cb764d978f7ff838594e0fd4f1d.jpeg",
    "https://cdn.faire.com/fastly/d63d5cdd42655e191337808fe51d2634b901d54f5fdbbc384819c7d9733cf97c.jpeg",
    "https://cdn.faire.com/fastly/ee4b0eecfbbab7fa95d5f0fe3b2ddb454bcc2793e9b7221915cb31288b1184e7.jpeg",
    "https://cdn.faire.com/fastly/44843b5dfa3b2d6b8c43252da7e99b0c81c0f2b7a3b1e0b39eb69ae26d055930.jpeg",
    "https://cdn.faire.com/fastly/851d8cad878c6dee32c0c23b6aa76cb333fb0e03cc368713eae8a4e6378d857f.jpeg",
    "https://cdn.faire.com/fastly/e780563ca5332f7add85cbae94d07e9debe41d09f1680dca6f1286195106a293.jpeg",
    "https://cdn.faire.com/fastly/0faa10dcaee0d8b5c8ffb4ace15c142c2fb2a7a09e39059d6afec57ce1c69a6b.jpeg",
  ],
  priceDollars: 42,
  description:
    "Style # BTP3251\nStay stylish and comfortable in this ribbed crop top and leggings set. Designed for a sleek and modern look, this set offers a flattering fit with a stretchy, ribbed texture that moves with you. The high-waisted leggings provide a sculpting effect, while the crop top enhances your natural shape. Perfect for lounging, workouts, or casual outings, this set is a must-have for an effortlessly chic ensemble.\n\n-Ribbed texture for a stylish look\n-Sleeveless crop top with a scoop neckline\n-High-waisted leggings for a flattering fit\n-Stretchy and comfortable fabric\n-Versatile for lounging, casual wear, or active days\n\nribbed crop top, two-piece set, high-waisted leggings, lounge set, athleisure wear, seamless leggings, casual activewear, stretchy leggings, women's workout set\n\nModel is 5' 8\" and wearing a S.",
  tags: [],
  msrpDollars: 132,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:01.762Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
